/* eslint-disable indent */
import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router';
import {useRecoilState, useRecoilValue, useResetRecoilState} from 'recoil';
import {favoriteColors,
  chosenColorsArray,
  chosenColorsFilters,
  colorsFiltered,
  searchQuery,
} from '../state/colors';
import UICardHeader from '../components/UICommon/UICardHeader';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UIButton from '../components/UICommon/UIButton';
import UIModal from '../components/UICommon/UIModal';
import ChooseColorsFavorite from '../components/ChooseColorsPage/ChooseColorsFavorite';
import ChooseColorsAllColors from '../components/ChooseColorsPage/ChooseColorsAllColors';
import ChooseColorsFilters from '../components/ChooseColorsPage/ChooseColorsFilters';
import useFetchFavoriteColors from '../hooks/useFetchFavoriteColors';
import useFetchAllColors from '../hooks/useFetchAllColors';
import useFetchFilters from '../hooks/useFetchFilters';

const ChooseColorPage: React.FC = () => {
  const history = useHistory();
  const colorsData: any = useRecoilValue(colorsFiltered);
  const favoriteColorsData: any = useRecoilValue(favoriteColors);
  const [chosenColors, setChosenColors] = useRecoilState(chosenColorsArray);
  const [isUpdatingFavorites, setUpdateFavorites] = useState(null) as any;
  const [filter, setFilter] = useRecoilState(chosenColorsFilters);
  const [search, setSearch] = useRecoilState(searchQuery);
  const resetSearchQuery = useResetRecoilState(searchQuery);
  const isActiveFilter = search.length > 0 || filter.length > 0;

  const {
    isLoading: isColorsLoading,
    isError: isColorsError,
    mutate: mutateFetchColors,
  } = useFetchAllColors();

  const {
    isLoading: isFavoritesLoading,
    isError: isFavoritesError,
    mutate: mutateFetchFavorites,
    isSuccess: isFetchFavoritesSuccess,
  } = useFetchFavoriteColors();

  const {
    isLoading: isFiltersLoading,
    isError: isFilterErrors,
    mutate: mutateFetchFilters,
  } = useFetchFilters();

  useEffect(() => {
    mutateFetchColors();
    mutateFetchFavorites();
    mutateFetchFilters();
  }, []);

  useEffect(() => {
    setUpdateFavorites(null);
  }, [isFetchFavoritesSuccess]);

  const submit = () => {
    setChosenColors(chosenColors);
    history.push('/fargdeklaration/new');
  };

  const resetFilters = () => {
    setFilter([]);
    resetSearchQuery();
    setSearch('');
  };

  if (isFiltersLoading) {
    return <UILoadingIndicator/>;
  }

  if (isFilterErrors || isColorsError || isFavoritesError) {
    return <UIErrorIndicator />;
  }

  return (
    <div className='md:px-6 h-full pb-5 flex flex-col justify-between font-Outfit overflow-y-scroll'>
      {isUpdatingFavorites && (
        <UIModal message={`${isUpdatingFavorites.isAdd ? 'Lägger till färg i' : 'Tar bort färg från'} favoriter`}/>
      )}
      <div className='bg-white z-20 w-full md:w-[94%] px-6 md:px-0 md:pt-4 pt-2'>
        <div className='flex justify-between items-center'>
          <UICardHeader title="Färger" padding={false}/>
          {isActiveFilter &&
          <UIButton type='outline' text='Återställ filter'
            style='pb-4 md:hidden' onClick={resetFilters}/>}
        </div>
        <ChooseColorsFilters/>
      </div>
      <div className='flex flex-grow flex-col pt-4 pb-36 md:pb-16 px-6 md:px-0'>
        <div className='min-h-[255px]'>
          <div className='flex justify-between'>
            <div className='font-medium text-base pb-4'>Mina favoriter</div>
            {isActiveFilter && <UIButton type='outline' text='Återställ filter'
              style='hidden md:block' onClick={resetFilters} />}
          </div>
          {isFavoritesLoading ? <UILoadingIndicator/> :
             <ChooseColorsFavorite
            colors={favoriteColorsData}
            setIsLoadingFavorites={() => setUpdateFavorites({isAdd: false})}
            refetchFavorites={mutateFetchFavorites}
            setChosenColors={setChosenColors}
            chosenColors={chosenColors}
            />
          }
        </div>
        <div className='h-[1px] bg-navy-primary w-[99%]'></div>
        <div className='min-h-[240px]'>
          <div className='flex justify-between items-center py-4 w-[99%]'>
            <div className='font-medium text-base py-5'>Färger</div>
          </div>
          {isColorsLoading ? <UILoadingIndicator/> :
           colorsData?.length === 0 ? (
            <div
              className='text-gray-500 text-center text-sm font-semibold'
            >Vi hittade inga färger, testa att återställ filter</div>
          ) : (
            <>
              <ChooseColorsAllColors
                colors={colorsData}
                setIsLoadingFavorites={() => setUpdateFavorites({isAdd: true})}
                refetchFavorites={mutateFetchFavorites}
                setChosenColors={setChosenColors}
                chosenColors={chosenColors}/>
          </>
          )}
        </div>
      </div>
      <div
        className='flex justify-center items-start pb-5 md:pb-3 pt-2 fixed bottom-0 w-full z-30 h-40 md:h-20'>
        <UIButton text='Spara valda färger' type='full' style='w-[152px]' onClick={submit}/>
      </div>
    </div>
  );
};

export default ChooseColorPage;
